const getYouTubeUrl = (embedUrl) => {
  try {
    const url = new URL(embedUrl);
    const videoId = url.pathname.match(/^\/embed\/([^/]+)/)?.[1];

    return videoId ? `https://www.youtube.com/watch?v=${videoId}` : embedUrl;
  } catch (_) {
    return embedUrl;
  }
};

const getConsentMessage = (video) => [
  video.previousElementSibling,
  video.nextElementSibling,
  video.parentElement?.previousElementSibling,
  video.parentElement?.nextElementSibling,
].find((element) => element?.classList.contains('cookieconsent-optout-marketing'));

const updateVideos = () => {
  const canRenewConsent = typeof window.Cookiebot?.renew === 'function';
  const blockedVideos = document.querySelectorAll(
    'iframe[data-cookieblock-src*="youtube"], iframe[data-cookieconsent~="marketing"][src*="youtube"]',
  );

  blockedVideos.forEach((video) => {
    const consentMessage = getConsentMessage(video);
    const consentLink = consentMessage?.querySelector('a');

    if (!consentLink) {
      return;
    }

    const youtubeLink = document.createElement('a');
    youtubeLink.href = getYouTubeUrl(video.dataset.cookieblockSrc || video.src);
    youtubeLink.target = '_blank';
    youtubeLink.rel = 'noopener noreferrer';
    youtubeLink.textContent = 'YouTube';

    if (canRenewConsent) {
      consentLink.parentElement.append(' Of bekijk de video op ', youtubeLink, '.');

      return;
    }

    video.setAttribute('hidden', '');
    consentLink.parentElement.replaceChildren(
      'Bekijk de video op ',
      youtubeLink,
      '.',
    );
  });
};

const init = () => {
  if (document.readyState === 'complete') {
    updateVideos();

    return;
  }

  window.addEventListener('load', updateVideos, { once: true });
};

export default {
  init,
};
